import React from 'react';
import {connect} from "react-redux";
import Popup from "../../../parts/Popup";
import CommonTab from "../../../parts/CommonTabClass";

class TenderTypesPublicationCostTypeComponent extends CommonTab {
    state = {
        tenderPublicationCostType: this.props.tenderPublicationCostType,
        errors: [],
        validateFields: [
            'tenderpublicationcosttypename',
            'tenderpublicationcosttypenameeng'
        ]
    };

    changeState(name, e) {
        let temp = this.state.tenderPublicationCostType;
        temp[name] = e.value;
        this.setState({tenderPublicationCostType: temp});
    }



    render() {
        let {tenderPublicationCostType, errors, validateFields} = this.state;
        let {close} = this.props;
        return (
            <Popup openClose={close}>
                <div className={'popup-content-types'}>
                    <form onSubmit={event => {
                        event.preventDefault();
                        this.formValidation(tenderPublicationCostType, validateFields);
                    }}>
                        <h2>{this.props.button} Tender Publication Cost Type</h2>
                        <table className={'table table-striped'} align={'right'}>
                            <tbody>
                            <tr>
                                <td>Tender Publication Cost Type Name :</td>
                                <td className={errors.indexOf('tenderpublicationcosttypename') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={tenderPublicationCostType.tenderpublicationcosttypename}
                                        onChange={(e) => {
                                            this.changeState('tenderpublicationcosttypename', e.target);
                                        }}
                                    />
                                    {errors.indexOf('tenderpublicationcosttypename') !== -1 ? <span className="errorText">Please set Cost Type Name</span> : '' }
                                </td>
                            </tr>
                            <tr>
                                <td>Tender Publication Cost Type Nameeng :</td>
                                <td className={errors.indexOf('tenderpublicationcosttypenameeng') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={tenderPublicationCostType.tenderpublicationcosttypenameeng}
                                        onChange={(e) => {
                                            this.changeState('tenderpublicationcosttypenameeng', e.target);
                                        }}
                                    />
                                    {errors.indexOf('tenderpublicationcosttypenameeng') !== -1 ? <span className="errorText">Please set Cost Type Name Eng</span> : '' }
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <input type={"submit"} className={"btn btn-primary"} value={this.props.button}/>
                    </form>
                </div>
            </Popup>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let content = {};
    state.tenderPublicationCost.map((item) => {
        if (item.tenderpublicationcosttypeid == ownProps.id) {
            content = item;
        }
    });
    return {
        tenderPublicationCostType: Object.assign({}, content)
    }
};

const TenderTypesPublicationCostTypePopup = connect(mapStateToProps)(TenderTypesPublicationCostTypeComponent);

export default TenderTypesPublicationCostTypePopup;